import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    dataAnalyticsActionTypes, 
    GET_DATAANALYTICS_API, 
    
} from '../constants/ApiConstants';

export const getDataAnalytics = (patientId,targetIds,fromDate,toDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(dataAnalyticsActionTypes.get_DataAnalytics.REQUEST));
        fetch(`${GET_DATAANALYTICS_API}?patientId=${patientId}&behaviorsReductionIds=${targetIds}&fromDate=${fromDate}&toDate=${toDate}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(dataAnalyticsActionTypes.get_DataAnalytics.SUCCESS, response));
                } else {
                    dispatch(actionCreator(dataAnalyticsActionTypes.get_DataAnalytics.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_DataAnalytics', error);
            });
    };
};




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalyticsBehaviors/actions/dataAnalyticsActions.js